import { CommonModule, DatePipe, NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { DatasearchService } from '../../_services/datasearch.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-our-events',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgFor, RouterLink, CommonModule],
  templateUrl: './our-events.component.html',
  styleUrl: './our-events.component.scss',
  providers: [DatePipe]
})
export class OurEventsComponent {
  transparent = false;
  eventsList: any = [];
  // eventImageBaseUrl = '../../../assets/DummyImages/events/';  
  // logoBaseUrl = '../../../assets/DummyImages/logo/';
  eventImageBaseUrl = '';
  logoBaseUrl = '';
  head: any[] = [];
  currentPage: string = 'event';
  constructor(private datasearch: DatasearchService, private router: Router, private datePipe: DatePipe) {
    this.eventImageBaseUrl = this.datasearch.ApiUrl + '/uploads/events/';
    this.logoBaseUrl = this.datasearch.ApiUrl + '/uploads/events/';
  }

  ngOnInit() {
    this.getEvents();
    this.getHeading();

  }
  isSameDate(startDate: string | Date, endDate: string | Date): boolean {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return start.toDateString() === end.toDateString();
  }
  getEvents() {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    // this.eventsList.push({_id: 1, title: 'Standards and Scientific Advice on Food and Nutrition', logo: '1.png', image: '1.png', 
    // location: 'E-15, Block E, East of Kailash, New Delhi, Delhi 110065, India', date: '22-01-2024', start_time: '08:00 am', end_time: '05:00 pm'});
    // this.eventsList.push({_id: 2, title: 'Monitoring Nutritional Status & Food Safety Events', logo: '2.png', image: '2.png', 
    // location: '2E/8, Third Floor, Jhandewalan Extension, Jhandewalan, New Delhi, Delhi 110055, India', date: '22-01-2024', start_time: '08:00 am', end_time: '05:00 pm'});
    // this.eventsList.push({_id: 3, title: 'Standards and Scientific Advice on Food and Nutrition', logo: '3.png', image: '3.png', 
    // location: 'A 67-70, 2nd and 3rd Floor Palam Extension, Sector- 7, New Delhi, Delhi 110077, India', date: '22-01-2024', start_time: '08:00 am', end_time: '05:00 pm'});
    // this.eventsList.push({_id: 4, title: 'Standards and Scientific Advice on Food and Nutrition', logo: '4.png', image: '4.png', 
    // location: 'Connaught Place 1-A, Hamilton House Building No. 1 & 2, New Delhi, Delhi 110001, India', date: '22-01-2024', start_time: '08:00 am', end_time: '05:00 pm'});
    // this.eventsList.push({_id: 5, title: 'Standards and Scientific Advice on Food and Nutrition', logo: '5.png', image: '5.png', 
    // location: 'B1/10 (Basement) Road No.30 Near PC Jeweller, India, Paschim Vihar, Delhi, 110063, India', date: '22-01-2024', start_time: '08:00 am', end_time: '05:00 pm'});
    // this.eventsList.push({_id: 6, title: 'Standards and Scientific Advice on Food and Nutrition', logo: '6.png', image: '6.png', 
    // location: 'Ho.No.2, A5, Near Radha Krishna Mandir, Delhi, 110030, India', date: '22-01-2024', start_time: '08:00 am', end_time: '05:00 pm'});    
    this.datasearch.getEvents().subscribe(res => {
      // Filter only active events
      this.eventsList = res.data.filter((item: any) => item.isActive === true);
      
      this.eventsList.forEach((val: any) => {
        let dateArr = [];
        val.event_date ? dateArr = val.event_date.split('-') : '';
        val.date = dateArr[2];
        val.month = monthNames[dateArr[1] - 1];
        val.year = dateArr[0];
      });
      // console.log(this.eventsList);
    });
  }
  goToEventDetails(id: any) {
    this.router.navigate(['/events', id]);
  }
  getEventImageUrl(poster: string): string {
    if (!poster) return '';
    if (poster.toString().startsWith('http')) return poster;
    return this.eventImageBaseUrl + poster;
  }

  getLogoImageUrl(logo: string): string {
    if (!logo) return '';
    if (logo.toString().startsWith('http')) return logo;
    return this.logoBaseUrl + logo;
  }

  getHeading() {
    this.datasearch.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }
}
